import { createAsyncThunk } from '@reduxjs/toolkit';
import { Enums, Paths, Value } from '@utils/constants';
import { addLoading, removeLoading } from '../appAction';
import { axios } from '@utils/lib';

export const getApplicationIdAsync = createAsyncThunk(
  'api/getApplicationIdAsync',
  async (query: IApplicationIdListQuery, { rejectWithValue, dispatch }) => {
    const searchQuery: Record<string, string> = {
      populate: 'ssid,user',
      'pagination[page]': query.page ?? Value.TABLE_PAGE_INIT,
      'pagination[pageSize]': query.pageSize ?? Value.TABLE_PAGE_SIZE,
      sort: 'id:desc',
    };
    if (query.userId) searchQuery['filters[user][id]'] = query.userId;
    if (query.disabled) searchQuery['filters[disabled][$eq]'] = query.disabled;
    if (query.appId) searchQuery['filters[appId]'] = query.appId;
    if (query.name) searchQuery['filters[name][$contains]'] = query.name;
    if (query.username)
      searchQuery['filters[user][username][$contains]'] = query.username;
    if (query.startDate)
      searchQuery['filters[usage][$fromDate]'] = query.startDate;
    if (query.endDate) searchQuery['filters[usage][$toDate]'] = query.endDate;

    const params = new URLSearchParams(searchQuery).toString();
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IListRes<IApplicationData>>(
        Enums.HTTP_METHOD.GET,
        Paths.APPLICATIONS + '?' + params,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const changeActiveStatusApplicationIdAsync = createAsyncThunk(
  'api/changeActiveStatusApplicationIdAsync',
  async (body: IChangeActiveForm, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { id } = body;
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.PATCH,
        Paths.APPLICATIONS + '/' + id,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const registerClusterDBAsync = createAsyncThunk(
  'api/registerClusterDBAsync',
  async (body: ICreateDBName, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const {
      id,
      db_name,
      size,
      retentionPeriod,
      highThreshold,
      lowThreshold,
      referenceThreshold,
    } = body;
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.POST,
        Paths.FACE_DB.replace(':appId', String(id)),
        {
          name: db_name,
          size,
          retentionPeriod,
          lowThreshold,
          highThreshold,
          referenceThreshold,
        },
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const registerApplicationAsync = createAsyncThunk(
  'api/registerApplicationAsync',
  async (body: IApplicationSumaryForm, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { appName, userId, ssidId, privateDbInitSize, maxPrivateDb } = body;
    const bodyPost = {
      name: appName,
      user: userId,
      ssid: ssidId,
      privateDbInitSize,
      maxPrivateDb,
    };
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.POST,
        Paths.APPLICATIONS,
        bodyPost,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const updateApplicationAsync = createAsyncThunk(
  'api/updateApplicationAsync',
  async (body: IApplicationSumaryForm, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { id, appName } = body;
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.PUT,
        Paths.APPLICATIONS + '/' + id,
        { name: appName },
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);
